module.exports = __webpack_public_path__ + "static/fee01-99826c8b5c37ca1f1b5968fb03c7df91.png";